import React from 'react'
import './Boswana.css'
import { processedTitle } from '../ConfigItem';

export default function Boswana({keyName, kInfo}) {
  const proTitle = processedTitle(kInfo.title, keyName);  
  return (
    <div className='boswana'>
      <div className='bosTitle'>
        {proTitle} 
      </div>
      <div className='bosKey'>
        {keyName}
      </div>
    </div>
  )
}
